import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import useSWRMutation from 'swr/mutation';
import { RECAPTCHA_HEADER } from '@/app/api/consts';
import { ROUTES } from '@/routes';
import { WitchReCaptcha } from '@/types/global';
import { ContactHostATMPostBody } from '../../types';
export const useHostArmForm = () => {
  const $ = _c(5);
  const {
    trigger,
    isMutating
  } = useSWRMutation(ROUTES.APIHostATMForm, _temp);
  let t0;
  if ($[0] !== trigger) {
    t0 = async (data, recaptchaToken) => {
      await trigger({
        ...data,
        recaptchaToken
      });
    };
    $[0] = trigger;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onSubmit = t0;
  let t1;
  if ($[2] !== isMutating || $[3] !== onSubmit) {
    t1 = {
      onSubmit,
      isLoading: isMutating
    };
    $[2] = isMutating;
    $[3] = onSubmit;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
};
async function _temp(url, t0) {
  const {
    arg
  } = t0;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      [RECAPTCHA_HEADER]: arg.recaptchaToken
    },
    body: JSON.stringify(arg)
  });
  if (!response.ok) {
    throw Error("Form request failed");
  }
  return true;
}